export class ContactDTO {
    public name: string;
    public email: string;
    public cell: string;

    constructor(sub?) {
        sub = sub || {};

        this.name = sub.name || null;
        this.email = sub.email || null;
        this.cell = sub.cell || null;
    }
}
